import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: { marginBottom: 30 },
  fieldsContainerAddon: {
    display: 'grid',
    gridTemplateColumns: '0.9fr 0.9fr 0.9fr 0.9fr 2.8fr',
    columnGap: 18,
    alignItems: 'center',
    marginBottom: '20px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
      columnGap: 8
    },
    [theme.breakpoints.up(1440)]: {
      gridTemplateColumns: '1.2fr 1.2fr 1.2fr 1.2fr 3fr'
    },
    [theme.breakpoints.up(1800)]: {
      gridTemplateColumns: '2fr 2fr 2fr 2fr 3fr',
      columnGap: 25
    },
    [theme.breakpoints.up(2200)]: {
      columnGap: 40
    }
  },
  iconButton: { marginRight: '34px' },
  header: {
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  mainButtonBase: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '-9px'
  },
  textCheckBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    [theme.breakpoints.up(2200)]: {
      justifyContent: 'space-around'
    }
  },
  addIcon: {
    color: theme.palette.primary.main,
    borderRadius: 50
  },
  addIconDisabled: {
    color: theme.palette.grey[400]
  },
  addIconHidden: {
    opacity: 0
  },
  addIconText: {
    color: theme.palette.primary.main
  },
  addIconDelete: {
    '&:hover': {
      color: theme.palette.primary.main
    }
  },
  lineSection: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      marginTop: '20px'
    }
  },
  lineSectionContainer: {
    width: '1px',
    border: `1px dashed${theme.palette.grey[400]}`,
    height: '100%',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  fontFamilyInput: {
    fontFamily: 'IranSans'
  },
  codeInputDisabled: {
    color: theme.palette.grey[500]
  }
}))
export default useStyles
